import * as React from 'react';
import { useQueryString } from 'hooks/useQueryString';
import { appendQueryString } from 'lib/util/appendQueryString';
import { useTranslation } from 'react-i18next';
import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { InstantWin } from 'models/instantWin';
import { InstantWinEvent } from 'models/instantWinEvent';

import styles from './Prize.module.css';

interface Props {
  onClose: () => void;
  instantWin: InstantWin;
  instantWinEvent: InstantWinEvent;
  tierKey: string;
}

export const ETicket = ({ onClose, instantWin, instantWinEvent, tierKey }: Props): any => {
  const { t } = useTranslation();
  const { apiKey, useApiKeyInPaths } = React.useContext(ApiKeyContext);

  const reservationId = instantWinEvent?.created_reservation_id ?? '';
  const tier = instantWin?.tiers?.find((tier) => tier?.key === tierKey);
  const keyVisual = tier?.thumbnail_url;
  const title = tier?.title;
  const description = tier?.description;

  const queryString = useQueryString();

  let eTicketPath = '/eticket';
  if (useApiKeyInPaths) {
    eTicketPath = `/${apiKey}${eTicketPath}`;
  }

  const eTicketUrl = appendQueryString(eTicketPath, `${queryString}&r=${reservationId}`);

  return (
    <>
      <div className={styles.ticketContainer1}>
        <div className={styles.congratsSection}>
          <div className={`${styles.divider} ${''}`} />
          <div className={styles.congratsText}>Congratulations!</div>
          <div className={`${styles.divider} ${''}`} />
        </div>
        <div className={styles.ticketPreview}>
          <img src={keyVisual} alt="e-ticket" className={styles.ticketImage} />
          <h2 className={styles.ticketName}>{title}</h2>
        </div>
      </div>

      <div className={styles.ticketContainer}>
        <div className={styles.ticketTitle}>{description}</div>
        <div className={styles.ticketDate}>
          {t('Participation Date')} : {instantWinEvent?.e_ticket_date_local_from || '-'} ~{' '}
          {instantWinEvent?.e_ticket_date_local_to || '-'}
        </div>
        <div className={styles.buttonGroup}>
          <a href={eTicketUrl} target="_blank" rel="noreferrer">
            <button className={styles.primaryButton}>{t('Show Ticket')}</button>
          </a>
          <button className={styles.secondaryButton} onClick={onClose}>
            {t('Close')}
          </button>
        </div>
      </div>
    </>
  );
};
